export const QUERY_PARAM_PAGINATION_KEY = 'page' as const
